import React from 'react';
import moment from 'moment';

function BnlDashboardNotice(props) {
  const NOTICE_START_DAY = '2025-11-19';
  const NOTICE_LAST_DAY = '2026-01-05';

  const { companyAuthToken } = props;

  // TODO: store this config in the database
  const companiesWithHolidayMessage = [
    'jellyjar',
    'gb',
    'bnl',
    'normandy',
    'tipping',
    'marcel',
    'classact',
    'bielmar',
    'wagner',
    'sportsjournal',
  ];

  const dashboardNoticeStyle = {
    background: '#ffffff',
    borderRadius: '5px',
    marginBottom: '25px',
    padding: '25px 25px 10px 25px',
    textAlign: 'center',
  };

  const noticeHeaderStyle = {
    marginTop: '0',
    marginBottom: '15px',
    // fontStyle: 'italic',
  };

  const noticeParagraphStyle = {
    marginBottom: '15px',
  };

  if (
    moment().isAfter(NOTICE_START_DAY, 'day') &&
    moment().isBefore(NOTICE_LAST_DAY, 'day') &&
    companiesWithHolidayMessage.includes(companyAuthToken)
  ) {
    return (
      <div
        className="bnl-gallery-dashboard-notice"
        style={dashboardNoticeStyle}
      >
        <h3 style={noticeHeaderStyle}>⚠️ Holiday Delivery Notice ⚠️</h3>
        <p style={noticeParagraphStyle}>
          Please place your order&nbsp;
          <strong>BEFORE</strong>
          &nbsp;12/12/25 to ensure you receive your products before 12/23/25.
        </p>
        <p style={noticeParagraphStyle}>
          All orders placed&nbsp;
          <strong>AFTER</strong>
          &nbsp;12/12/25 will be processed but may not arrive prior to 12/23/25.
        </p>
        <p style={noticeParagraphStyle}>
          All orders placed 12/20/25 through 1/4/26 will be processed and
          shipped 1/5/26.
        </p>
        <p style={noticeParagraphStyle}>
          Please note: Digital download products will be sent 24 hours after
          they are ordered.
        </p>
      </div>
    );
  }
  return null;
}

export default BnlDashboardNotice;
